import { BulkPriceSchemeItem } from '../../models/response/bulkPrice/BulkPriceResponses';

/**
 * Listeden seçilen şablonlar detay ekranına burada taşınır.
 * Adres satırına konulmadı: çok şablon seçilince adres çok uzuyor.
 * Sekme belleğinde durduğu için sayfa yenilense de seçim kaybolmaz.
 */
const ANAHTAR = 'toplu-fiyat-secilen-sablonlar';

export function secimiYaz(sablonlar: BulkPriceSchemeItem[]) {
    try {
        sessionStorage.setItem(ANAHTAR, JSON.stringify(sablonlar));
    } catch {
        // Sekme belleği kapalıysa seçim taşınamaz; detay ekranı uyarı gösterir.
    }
}

export function secimiOku(): BulkPriceSchemeItem[] {
    try {
        var ham = sessionStorage.getItem(ANAHTAR);
        return ham ? JSON.parse(ham) : [];
    } catch {
        return [];
    }
}
